import { useState } from 'react';
import { useFetch } from './useFetch';
import { getShortAgents } from '../api';

export const useAgentsMap = () => {
  const [agentsMap, setAgentsMap] = useState<{
    [id: string]: string;
  } | null>(null);

  useFetch(async () => {
    if (!agentsMap) {
      const agents = await getShortAgents();
      const map = (agents ?? []).reduce<Record<string, string>>(
        (acc, agent) => {
          if (agent.id) {
            acc[agent.id] = agent.title ?? '';
          }
          return acc;
        },
        {}
      );
      setAgentsMap(map);
    }
    return null;
  }, []);

  return agentsMap;
};
